import { blackColor } from "../../utils/constants/compareParts";

export function fillHeaderCompareSvg(color = blackColor) {
    const svgCompare = document.querySelector(".header-compare svg");

    if (svgCompare) {
        svgCompare.style.fill = color;
    }
}